import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    connectionStatus: null,
    user: null,
    userProfile: null,
    buying: null,
    waitingLoginPage: null,
    screenSize: [0, 0],
    paymentsToBeVerified: []
  },
  mutations: {
    addPaymentToBeVerified (state, { payment }) {
      state.paymentsToBeVerified.push(payment)
      console.log(state.paymentsToBeVerified)
    },
    removePaymentToBeVerified (state, { payment }) {
      state.paymentsToBeVerified.splice(state.paymentsToBeVerified.indexOf(payment), 1)
    },
    updateConnectionStatus (state, status) {
      state.connectionStatus = status
    },
    updateValue (state, { value, key }) {
      Vue.set(state, key, value)
    },
    updateUser (state, { value }) {
      state.user = value
    },
    updateUserProfile (state, { value }) {
      Vue.set(state, 'userProfile', value)
      // state.userProfile = value
    },
    updateBuying (state, { value }) {
      state.buying = value
    },
    registerScreenSize (state, { w, h }) {
      state.screenSize = [w, h]
    }
  }
})
